import { BACKEND_URL_STORE } from '@constants/server.constant'
import axios from 'axios'

export const sendOtp = (payload: { phone: string }) =>
  axios.post(`${BACKEND_URL_STORE}/customers/otp/send`, payload)

export const resendOtp = (payload: { phone: string; channel: string }) =>
  axios.post(`${BACKEND_URL_STORE}/customers/otp/resend`, payload)

export const verifyOtp = (payload: { otp?: string; phone?: string }) =>
  axios.post(`${BACKEND_URL_STORE}/customers/otp/verify`, payload)
